import { useRef, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import InvoiceCreateForm from '../components/Invoice/InvoiceCreateForm';
import { t } from '../i18n';

const apiUrl = process.env.REACT_APP_API_URL;

// Serves both /invoices/create (new) and /invoices/edit/:id + /invoices/create/:id
// (edit). Editing loads the invoice first and only then renders the form, so
// the form never shows defaults that get swapped out a moment later.
export default function InvoiceCreatePage() {
  const { id: invoiceId } = useParams();
  const [searchParams] = useSearchParams();
  const invoiceFormRef = useRef();

  const [existingInvoiceData, setExistingInvoiceData] = useState(null);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    if (!invoiceId) return;
    let cancelled = false;
    setExistingInvoiceData(null);
    setLoadError('');

    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${apiUrl}/invoice-view/${invoiceId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) {
          throw new Error(res.status === 404 ? t('Фактурата не е пронајдена.') : t('Грешка: {status}', { status: res.status }));
        }
        const data = await res.json();
        if (!cancelled) setExistingInvoiceData(data);
      } catch (error) {
        if (!cancelled) setLoadError(error.message || t('Фактурата не може да се вчита.'));
      }
    })();

    return () => { cancelled = true; };
  }, [invoiceId]);

  // ?type=dispatch opens the form on Испратница — that is how the Испратници
  // list's "Нова Испратница" button gets here. Anything else means Фактура.
  const initialDocumentType = searchParams.get('type') === 'dispatch' ? 'dispatch' : 'invoice';

  if (invoiceId && loadError) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 text-sm">{loadError}</div>
      </div>
    );
  }

  if (invoiceId && !existingInvoiceData) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 text-sm text-gray-500">{t('Вчитување на фактурата...')}</div>
    );
  }

  return (
    <InvoiceCreateForm
      key={invoiceId || 'new'}
      ref={invoiceFormRef}
      isEdit={!!invoiceId}
      existingInvoiceData={existingInvoiceData}
      initialDocumentType={invoiceId ? 'invoice' : initialDocumentType}
    />
  );
}
